const appendButtonBelowOrderInformation = () => {
  const newButton = document.createElement("button");
  newButton.classList.add("back-to-shop");
  newButton.innerText = "Terug naar de shop";
  const targetSection = document.querySelector(
    "section.woocommerce-order-details"
  );
  targetSection?.appendChild(newButton);
};

try {
  appendButtonBelowOrderInformation();
} catch (err) {
  console.error(err);
}
